module.exports = __webpack_public_path__ + "static/media/fullimg.f17c3dc9.jpg";